(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-brands-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__brandsShowcaseJumpInit) return;
  window.__brandsShowcaseJumpInit = true;

  // The brand count can exceed Shopify's 50-block-per-section limit, so the
  // template splits it across multiple `custom-brands-showcase` instances.
  // Merge their grids into one continuous list so row-wrapping and the total
  // count are correct regardless of where the split landed.
  function mergeGridSections() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.custom-brands-showcase'));
    if (sections.length < 2) return;
    var primaryGrid = sections[0].querySelector('.custom-brands-showcase__grid');
    if (!primaryGrid) return;
    for (var i = 1; i < sections.length; i++) {
      var grid = sections[i].querySelector('.custom-brands-showcase__grid');
      if (!grid) continue;
      while (grid.firstChild) {
        primaryGrid.appendChild(grid.firstChild);
      }
      sections[i].style.display = 'none';
    }
  }

  function updateCountBadge(total) {
    var badge = document.querySelector('.custom-brands-showcase__count-badge');
    if (!badge) return;
    badge.textContent = total + ' μάρκες διαθέσιμες';
  }

  function init() {
    mergeGridSections();

    var allItems = document.querySelectorAll('.custom-brands-showcase__item');
    if (allItems.length) updateCountBadge(allItems.length);

    var items = Array.prototype.slice.call(
      document.querySelectorAll('.custom-brands-showcase__item[data-letter]')
    );
    if (!items.length) return;

    // One anchor card per letter (first occurrence) — used for both the
    // click/jump target and the scrollspy observer, same as a single
    // heading-per-letter would have been, but with no visible divider.
    var letters = [];
    var anchors = {};
    items.forEach(function (item) {
      var letter = item.getAttribute('data-letter');
      if (!anchors[letter]) {
        anchors[letter] = item;
        letters.push(letter);
      }
    });
    if (!letters.length) return;

    // Compact the index into a bounded number of rows so it stays short even
    // Compact into a fixed 7-way split regardless of how many distinct
    // letters are active, so the index reads as a positional guide ("where
    // am I in the alphabet") rather than a precise per-letter jump list.
    // Each row is still a full 44px tap target; a row covering more than
    // one letter shows its actual range (e.g. "A–D") and jumps to the
    // first letter in it.
    var TARGET_ENTRIES = 7;
    // Pin the last active letter (e.g. Z) as its own trailing pill, like a
    // contacts-index anchor — otherwise an even 7-way split folds it into
    // the final bucket and only that bucket's first letter is ever shown,
    // so the last letter of the alphabet never appears.
    var hasTrailingLetter = letters.length > 1;
    var groupLetters = hasTrailingLetter ? letters.slice(0, -1) : letters;
    var groupBucketCount = Math.min(groupLetters.length, TARGET_ENTRIES - (hasTrailingLetter ? 1 : 0));
    var buckets = [];
    var letterBucket = {};
    for (var bi = 0; bi < groupBucketCount; bi++) {
      var start = Math.floor((bi * groupLetters.length) / groupBucketCount);
      var end = Math.floor(((bi + 1) * groupLetters.length) / groupBucketCount);
      var bucketLetters = groupLetters.slice(start, end);
      buckets.push(bucketLetters);
      bucketLetters.forEach(function (l) {
        letterBucket[l] = bi;
      });
    }
    if (hasTrailingLetter) {
      var lastLetter = letters[letters.length - 1];
      letterBucket[lastLetter] = buckets.length;
      buckets.push([lastLetter]);
    }

    var nav = document.createElement('nav');
    nav.className = 'custom-brands-showcase__jumpnav';
    nav.setAttribute('aria-label', 'Μετάβαση σε γράμμα μάρκας');

    var pills = [];
    buckets.forEach(function (bucketLetters, i) {
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'custom-brands-showcase__jumplink';
      a.textContent = bucketLetters[0];
      a.setAttribute('aria-label', bucketLetters.join(', '));
      a.dataset.bucket = i;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        jumpTo(bucketLetters[0]);
      });
      nav.appendChild(a);
      pills.push(a);

      if (i < buckets.length - 1) {
        var dot = document.createElement('span');
        dot.className = 'custom-brands-showcase__jumpdot';
        dot.textContent = '•';
        dot.setAttribute('aria-hidden', 'true');
        nav.appendChild(dot);
      }
    });

    document.body.appendChild(nav);

    function jumpTo(letter) {
      var target = anchors[letter];
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setActive(letter) {
      var activeBucket = letterBucket[letter];
      pills.forEach(function (pill, i) {
        pill.classList.toggle('is-active', i === activeBucket);
      });
    }

    // Scroll-position-based scrollspy, not an IntersectionObserver band: a
    // narrow top "detection band" (the previous approach) never gets
    // reached by anchors near the end of the list once the page runs out of
    // room to scroll further, which left everything past the mid-point
    // permanently unhighlighted at the bottom of the page. Checking actual
    // position on every scroll avoids that — the last-passed anchor is
    // always resolvable, including with no scroll room left.
    var REFERENCE_OFFSET = 100;
    function updateActiveFromScroll() {
      var refY = window.scrollY + REFERENCE_OFFSET;
      var current = null;
      for (var i = 0; i < letters.length; i++) {
        var top = anchors[letters[i]].getBoundingClientRect().top + window.scrollY;
        if (top <= refY) {
          current = letters[i];
        } else {
          break;
        }
      }
      // The last one or two anchors can sit within the trailing content
      // (remaining grid rows + footer) close enough to the bottom that
      // refY never reaches them even at max scroll. Force the true last
      // letter active once there's no more room to scroll, so the index
      // always finishes fully lit instead of stalling a bucket or two short.
      var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atBottom && letters.length) {
        current = letters[letters.length - 1];
      }
      if (current) setActive(current);
    }

    // Only appear once the visitor actually starts scrolling, not on first paint.
    var SHOW_AFTER = 120;
    function onScroll() {
      nav.classList.toggle('is-visible', window.scrollY > SHOW_AFTER);
      updateActiveFromScroll();
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Drag/scrub across the pills to jump quickly, like a contacts-app index.
    var dragging = false;
    function handlePointer(e) {
      var el = document.elementFromPoint(e.clientX, e.clientY);
      var link = el && el.closest ? el.closest('.custom-brands-showcase__jumplink') : null;
      if (link && link.dataset.bucket !== undefined) {
        var bucketLetters = buckets[Number(link.dataset.bucket)];
        if (bucketLetters && bucketLetters.length) jumpTo(bucketLetters[0]);
      }
    }
    nav.addEventListener('pointerdown', function (e) {
      dragging = true;
      handlePointer(e);
    });
    nav.addEventListener('pointermove', function (e) {
      if (dragging) handlePointer(e);
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
